import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ListTable from "../../molecules/ListTable";
import { useReviewResultList } from "../../../api/review/hooks";
import { Select, SelectOption } from "../../atoms/Select";
import Button from "../../atoms/Button";
import { useEffect } from "react";
import styled, { css } from "styled-components";
import Paging from "../../organisms/Paging";

/**
 * 받은 리뷰 목록
 * - 일반 사용자용 화면
 */
const ReviewList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [pageNum, setPageNum] = useState(1);
    const [viewCount, setViewCount] = useState(15);

    const { data: data, isLoading, refetch } = useReviewResultList(pageNum, viewCount);
    const reviewResultList = data?.data?.review || [];

    useEffect(() => {
        console.log("@@reviewResultList Data:", data);
    }, [data]);

    useEffect(() => {
        refetch();
    }, [pageNum, viewCount, refetch]);

    return (
        <>
            <h2>받은 리뷰</h2>

            <div>
                <ListTable>
                    <thead>
                        <tr>
                            <th style={{ width: "5%" }} className="center">번호</th>
                            <th style={{ width: "85%" }}>제목</th>
                            <th style={{ width: "10%" }}>생성 날짜</th>
                        </tr>
                    </thead>

                    <tbody>
                        {reviewResultList?.length > 0
                            ? reviewResultList.map((el, idx) => {
                                return (
                                    <ReviewRow className="hover-row" key={el.idx} onClick={() => navigate(`/review/result/detail/${el.idx}`)}>
                                        <td className="seq">{idx + 1}</td>
                                        <td>
                                            {/* <span className={`status status-${el.status}`}>{el.is_hide === "1" ? "삭제" : el.status === "1" ? "대기" : el.status === "2" ? "진행" : el.status === "3" ? "확인" : el.status === "4" ? "종료" : null}</span> */}
                                            <span className="review-title">{el.title}</span>
                                        </td>
                                        <td className="date">{el.reg_date.split("T")[0]}</td>
                                    </ReviewRow>
                                );
                            })
                            : (
                                <tr className="empty-row">
                                    <td colSpan={3}>
                                        확인 가능한 리뷰가 없습니다
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </ListTable>
            </div>

            <Paging name={"review_result_list"} total={parseInt(data?.data?.total)} pageNumState={[pageNum, setPageNum]} viewCount={viewCount}></Paging>
        </>
    );
};

const ReviewRow = styled.tr`
    height: 58px;
    ${(props) =>
        props.active === false &&
        css`
            td {
                color: var(--lightgray-color);
                background-color: var(--light-color);
                pointer-events: none;
            }
        `}

    .review-title {
    }
`;

export default ReviewList;
